var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.49967 1.45703C4.09392 1.45703 1.33301 4.21794 1.33301 7.6237C1.33301 11.0295 4.09392 13.7904 7.49967 13.7904C10.9054 13.7904 13.6663 11.0295 13.6663 7.6237C13.6663 4.21794 10.9054 1.45703 7.49967 1.45703ZM0.333008 7.6237C0.333008 3.66566 3.54163 0.457031 7.49967 0.457031C11.4577 0.457031 14.6663 3.66566 14.6663 7.6237C14.6663 11.5817 11.4577 14.7904 7.49967 14.7904C3.54163 14.7904 0.333008 11.5817 0.333008 7.6237ZM6.99966 4.95703C6.99966 4.68089 7.22352 4.45703 7.49966 4.45703H7.50633C7.78247 4.45703 8.00633 4.68089 8.00633 4.95703C8.00633 5.23317 7.78247 5.45703 7.50633 5.45703H7.49966C7.22352 5.45703 6.99966 5.23317 6.99966 4.95703ZM7.49966 7.12369C7.77581 7.12369 7.99966 7.34754 7.99966 7.62369V10.2904C7.99966 10.5665 7.77581 10.7904 7.49966 10.7904C7.22352 10.7904 6.99966 10.5665 6.99966 10.2904V7.62369C6.99966 7.34754 7.22352 7.12369 7.49966 7.12369Z",
    fill: "#0F569C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.59ccacac2e2e3e8383a6c4d6554ce384.svg";
export { ForwardRef as ReactComponent };